import { authRoutes, router } from '.././router'
import { type QrErrorCode } from '../state'
import { postGetBody, type ProblemDetailsResponse } from './api'
import { authenticated, type AuthenticatedResponse } from './authentication-service'

export async function qrLogin(qrCode: string) {
  const parts = qrCode.split(':')
  if (parts.length !== 3) {
    await setError('Invalid')
  }
  const token = parts[1]
  const redirectUri = parts[2]
  const response = await postGetBody<AuthenticatedResponse | ProblemDetailsResponse>('login-qr-token', { token })
  if (response && 'user' in response) {
    await router.push(await authenticated(response, 'qr', redirectUri))
  } else {
    await setError(response ? (response.title as QrErrorCode) : 'Invalid')
  }
}

async function setError(qrErrorCode: QrErrorCode) {
  await router.push({ name: authRoutes.login.name, state: { qrErrorCode } })
}
